import { useFcmPush } from '@/features/notification/hooks/useFcmPush';

/** Mount-only bootstrap so FCM runs inside Query + Redux providers. */
export function FcmPushBootstrap() {
  useFcmPush();
  return null;
}
